// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ct-3";
export var flatBottomCorners = "_ct-5";
export var productImage = "_ct-0";
export var quantityContainer = "_ct-2";
export var quantityHeader = "_ct-6";
export var tooltip = "_ct-1";
export var wrapAndEllipsesOverflow = "_ct-4";